import StepFade from './StepFade'

export default StepFade